import { headerSignInStyles } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import { css } from "styled-components";

headerSignInStyles.signOutWrapper = {
    css: css`
        display: inline-flex;
        padding: 6px 0;
        margin:10px;
    `,
}

headerSignInStyles.titleIcon = {
    size: 22,
    css:css`
        color: #fff;
        height:20px;
        width: 20px;
    `,
}

headerSignInStyles.signOutClickable ={
    css: css`
        flex: 0 0 auto;
        margin-left: 20px;
        text-transform: uppercase;
        color: #fff;
        font-size:14px;
        font-weight:300;
    `,
}